/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  .page-top {
    padding: 12px 32px;
    border-bottom: 1px solid ${({ theme }) => theme.black15};
  }

  .btn-back {
    margin-top: 20px;
  }

  .page-title {
    margin-bottom: 10px;
  }

  .page-form {
    padding: 24px 32px;
    padding-top: 0;
    display: flex;
    justify-content: space-between;
  }

  .left-side {
    flex-basis: 47%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .right-side {
    flex-basis: 47%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .link-page .mock-children {
    overflow-y: auto;
    padding: 0;
  }

  .challenge-top {
    margin: 20px 0;
    text-align: center;
  }

  .day-tag {
    margin-bottom: 5px;
    text-align: center;
    color: #547756;
    border: 1px solid #547756;
    font-size: 12px;
    padding: 2px 5px;
    border-radius: 5px;
    display: inline-block;
  }

  .content-box {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f7f7f6;
    border-radius: 5px;
  }

  .box-title {
    font-size: 14px;
  }

  .box-content {
    font-size: 12px;
    margin: 10px 0;
    white-space: pre-line;
    word-wrap: break-word;
    & > div {
      white-space: pre-line;
      word-wrap: break-word;
    }
  }

  .box-icon {
   width: 20px;
   height: 20px;
   border-radius: 5px;
   font-size: 12px;
   text-align: center;
   line-height: 20px;
   margin-right: 5px;
  }
  .blue-icon {
    background-color: #bae7ff;
  }
  .yellow-icon {
    background-color: #fff188;
  }
  .pink-icon {
    background-color: #efdbff;
  }

  /* Collapse箭头移到右侧 */
  .right-side .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    padding: 10px 0;
  }

  .right-side .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
    margin-left: 0;
    margin-right: 8px;
    order: 1;
  }

  .right-side .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
    order: 0;
    flex: 1;
  }

  .right-side .ant-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
    
  .link-page {
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
  }

  /* Insight link preview (same card as Create Insight) inside a day's phone preview */
  .challenge-link-preview {
    margin-top: 10px;
    border: 1px solid #e4e1d9;
    border-radius: 10px;
  }
  .challenge-link-status {
    margin: 6px 0 0;
  }
`;

export const SharePageContainer = styled.div`
  font-family: 'Proxima Nova', sans-serif;
  min-height: 100vh;
  background-color: #f1efe8;
  position: relative;
  @media (min-width: 768px) {
    padding: 40px 20px;
    background-color: #f7f5f2;
  }
  
  .share-page-wrapper {
    max-width: 900px;
    margin: 0 auto;
    overflow: hidden;
    @media (min-width: 768px) {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      background-color: #f1efe8;
    }
  }
`;

export const QRCodeBox = styled.div`
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  background-color: #000000;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;

  svg {
    background-color: #ffffff;
    padding: 8px;
    border-radius: 4px;
  }

  .qr-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  span {
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 1.4;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;
